import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Button } from '@chakra-ui/react';
//
import { getStarted } from '../../state/actions/customers/customers';

function index() {
  const dispatch = useDispatch();

  const customersReducer = useSelector((state) => state.customersReducer);

  const validationSchema = Yup.object({
    email: Yup.string().email('Invalid email address').required('Required'),
    name: Yup.string().required('Required'),
    phone: Yup.string().required('Required'),
    number_of_students: Yup.string().required('Required'),
    school_name: Yup.string().required('Required'),
    message: Yup.string(),
  });

  // handle submit
  function handleSubmit(values, { resetForm }) {
    dispatch(getStarted(values));
    // todo: reset form after successful submission
    resetForm();
  }
  return (
    <div>
      <section className="bg-gradient-to-b from-gray-50 to-white text-gray-700 body-font relative pb-36">
        <div className="container px-5 py-24 mx-auto">
          <div className="flex flex-col text-center w-full mb-12">
            <h1 className="">Get Started</h1>
            <p className="lg:w-2/3 mx-auto leading-relaxed text-base">We'll be in touch soon!</p>
          </div>
          <Formik
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            initialValues={{
              email: '',
              name: '',
              school_name: '',
              message: '',
              phone: '',
              number_of_students: 0,
            }}
          >
            {({ errors, handleSubmit, handleChange, handleBlur, values, touched }) => (
              <form onSubmit={handleSubmit} className="lg:w-1/2 md:w-2/3 mx-auto">
                <div className="flex flex-wrap -m-2">
                  <div className="p-2 w-full">
                    <div className="relative">
                      <label htmlFor="name" className="leading-7  ">
                        Your name
                      </label>
                      <input
                        // placeholder="Bob Collymore"
                        // id="name"
                        name="name"
                        // type="name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.name}
                        className={`form-input ${
                          touched.name && errors.name ? 'border-red-500' : ''
                        }`}
                      />
                      {touched.name && errors.name ? (
                        <p className="text-red-600">{errors.name}</p>
                      ) : null}
                    </div>
                  </div>

                  <div className="p-2 w-full md:w-1/2">
                    <div className="relative">
                      <label htmlFor="email" className="leading-7  ">
                        Your email address
                      </label>
                      <input
                        // placeholder="bobcollymore@saf.com"
                        // id="email"
                        name="email"
                        type="email"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.email}
                        className={`form-input ${
                          touched.email && errors.email ? 'border-red-500' : ''
                        }`}
                      />
                      <p className="text-xs text-gray-400">
                        Note that you will have to confirm your email address.
                      </p>
                      {touched.email && errors.email ? (
                        <p className="text-red-600">{errors.email}</p>
                      ) : null}
                    </div>
                  </div>

                  <div className="p-2 w-full md:w-1/2">
                    <div className="relative">
                      <label htmlFor="phone" className="leading-7  ">
                        Your phone number
                      </label>
                      <input
                        // placeholder="bobcollymore@saf.com"
                        // id="phone"
                        name="phone"
                        // //type="phone"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.phone}
                        className={`form-input ${
                          touched.phone && errors.phone ? 'border-red-500' : ''
                        }`}
                      />
                      <p className="text-xs text-gray-400">
                        Note that you will have to confirm your phone number.
                      </p>
                      {touched.phone && errors.phone ? (
                        <p className="text-red-600">{errors.phone}</p>
                      ) : null}
                    </div>
                  </div>

                  <div className="p-2 w-full md:w-1/2">
                    <div className="relative">
                      <label htmlFor="school_name" className="leading-7  ">
                        School name
                      </label>
                      <input
                        placeholder=""
                        // id="school_name"
                        name="school_name"
                        // type="school_name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.school_name}
                        className={`form-input ${
                          touched.school_name && errors.school_name ? 'border-red-500' : ''
                        }`}
                      />
                      {touched.school_name && errors.school_name ? (
                        <p className="text-red-600">{errors.school_name}</p>
                      ) : null}
                    </div>
                  </div>

                  <div className="p-2 w-full md:w-1/2">
                    <div className="relative">
                      <label htmlFor="number_of_students" className="leading-7  ">
                        Number of students in school (approximate)
                      </label>
                      <input
                        // placeholder="bobcollymore@saf.com"
                        // id="number_of_students"
                        name="number_of_students"
                        type="number"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.number_of_students}
                        className={`form-input ${
                          touched.number_of_students && errors.number_of_students
                            ? 'border-red-500'
                            : ''
                        }`}
                      />
                      <p className="text-xs text-gray-400">Help us curate a package for you.</p>
                      {touched.number_of_students && errors.number_of_students ? (
                        <p className="text-red-600">{errors.number_of_students}</p>
                      ) : null}
                    </div>
                  </div>

                  <div className="p-2 w-full">
                    <div className="relative">
                      <label htmlFor="message" className="leading-7  ">
                        Any special request/questions/comments? (Optional)
                      </label>

                      <textarea
                        placeholder=""
                        // id="message"
                        name="message"
                        // type="message"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.message}
                        className={`form-text-area ${
                          touched.message && errors.message ? 'border-red-500' : ''
                        }`}
                      />
                      {touched.message && errors.message ? (
                        <p className="text-red-600">{errors.message}</p>
                      ) : null}
                    </div>
                  </div>
                  <div className="my-4 mx-2 w-full">
                    <Button
                      type="submit"
                      className="analytics-get-started-button-submit "
                      colorScheme="brand"
                      isLoading={customersReducer.getStartedLoading}
                      isDisabled={customersReducer.getStartedLoading}
                      loadingText="Loading..."
                      borderRadius="0"
                    >
                      Get started
                    </Button>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </section>
    </div>
  );
}

export default index;
